import { createModel, RematchDispatch } from '@rematch/core';
import * as ChatbotService from '../../services/chatbot.service';
import baseEntity from './base.entity';
import { ChatbotType } from '../../types/chatbot.type';
import { RootModel } from '../models';
import { PaginationType } from '../../types/CommonTypes';

export const storeName = 'chatbotEntities';

interface ChatbotStateType {
  ids: { [id: number]: ChatbotType };
}

const chatbotEntities = createModel<RootModel>()({
  state: { ids: {} } as ChatbotStateType,
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof chatbotEntities>) => ({
    async load(payload): Promise<{ content: ChatbotType[] } & PaginationType> {
      try {
        const res = await ChatbotService.filter(payload);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }

    },
    async findById(payload, state): Promise<ChatbotType> {
      const item = state.chatbotEntities.ids[payload];
      if (item && !item.isSimplified) {
        return item;
      }
      const res = await ChatbotService.getById(payload);
      this.saves([res.data]);
      return res.data;
    },
    async delete(payload) {
      await ChatbotService.deleteById(payload);
      this.remove({ id: payload });
    },
    async save(payload) {
      let item;
      if (!payload.id) {
        ({ data: item } = await ChatbotService.create(payload));
      } else {
        ({ data: item } = await ChatbotService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    },
  }),
});

export default chatbotEntities;